import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"py-5 border-bottom\"><div class=\"container\"><h1 class=\"display-3\">Fold my paper!</h1><p class=\"lead\"> How many times can you fold a sheet of paper?<br>Experiments shows that any sheet of paper can me folded for maximum 7 times. This happens because the thickness of the paper becomes so hight that is impossibile to fold. </p><p class=\"lead\"> This simple project show how much the thickness of the paper rises exponentially when folded and allow us to calculate what thickness we would have if we could fold it more than X times. </p><p><em>Someone even says that if we fold a sheet of paper for 45 times, its thickness would be so hight that would cover the distance from Earth to the Moon. Let&#39;s try it! </em></p></div></div>", 1)
const _hoisted_2 = { class: "py-5 border-bottom bg-light" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row row-cols-1 row-cols-md-2" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "um" }, "Micron", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "mm" }, "Millimeters", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "row justify-content-center" }
const _hoisted_11 = { class: "col col-md-8" }
const _hoisted_12 = { class: "input-group-text" }
const _hoisted_13 = { class: "bg-dark text-light" }
const _hoisted_14 = { class: "py-5" }
const _hoisted_15 = { class: "container" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-4" }, " Let's see where can you arrive... maybe to the Moon! ", -1)
const _hoisted_17 = { class: "list-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInput = _resolveComponent("FormInput")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_FormInput, {
              label: "Paper thickness",
              modelValue: _ctx.thickness,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.thickness) = $event)),
              type: "number"
            }, {
              after: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  style: {"min-width":"140px","flex":"0"},
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.unit) = $event))
                }, _hoisted_8, 512), [
                  [_vModelSelect, _ctx.unit]
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_FormInput, {
              label: "Folding times",
              modelValue: _ctx.foldingTimes,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.foldingTimes) = $event)),
              type: "number"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_FormInput, {
              label: "Final thickness",
              "model-value": 
                _ctx.formatNumber(_ctx.finalThickness) + ' ' + _ctx.finalThicknessUnit
              ,
              readonly: ""
            }, _createSlots({
              after: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.formatNumber(_ctx.sheetsCount)) + " sheets ", 1)
              ]),
              _: 2
            }, [
              (_ctx.finalThicknessUnit === 'au')
                ? {
                    name: "message",
                    fn: _withCtx(() => [
                      _createElementVNode("small", null, _toDisplayString(_ctx.formatNumber(_ctx.finalThicknessKm)) + " km", 1)
                    ])
                  }
                : undefined
            ]), 1032, ["model-value"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("ul", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reachedDistances, (el) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "list-group-item",
                key: el.destination
              }, [
                _createElementVNode("strong", null, _toDisplayString(el.destination), 1),
                _createTextVNode(" - OK! (" + _toDisplayString(_ctx.formatNumber(el.distance)) + " km) ", 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}